import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { StaffCompaniesService } from 'lib-klab-sdks';
import { CompaniesPort } from '../../../app/ports/organization/companies.port';
import {
    Company,
    CompanyGeneralDataRequest,
    CompanyUpsertRequest,
} from '../../../domain/models/organization/company.model';
import {
    mapCompanyRequestToSdk,
    mapCompanyGeneralDataRequestToSdk,
    mapStaffCompanyToDomain,
} from '../../mappers/organization/company.mapper';

@Injectable({ providedIn: 'root' })
export class CompaniesPortAdapter implements CompaniesPort {
    constructor(private readonly companiesApi: StaffCompaniesService) {}

    list(): Observable<Company[]> {
        return this.companiesApi.list().pipe(map((companies) => companies.map(mapStaffCompanyToDomain)));
    }

    getById(companyId: number): Observable<Company> {
        return this.companiesApi
            .getById(companyId)
            .pipe(map(mapStaffCompanyToDomain));
    }

    create(request: CompanyUpsertRequest): Observable<Company> {
        return this.companiesApi
            .create(mapCompanyRequestToSdk(request))
            .pipe(map(mapStaffCompanyToDomain));
    }

    update(companyId: number, request: CompanyUpsertRequest): Observable<Company> {
        return this.companiesApi
            .update(companyId, mapCompanyRequestToSdk(request))
            .pipe(map(mapStaffCompanyToDomain));
    }

    updateGeneralData(
        companyId: number,
        request: CompanyGeneralDataRequest,
    ): Observable<Company> {
        return this.companiesApi
            .updateGeneralData(companyId, mapCompanyGeneralDataRequestToSdk(request))
            .pipe(map(mapStaffCompanyToDomain));
    }

    setStatus(companyId: number, active: boolean): Observable<Company> {
        return this.companiesApi
            .setStatus(companyId, active)
            .pipe(map(mapStaffCompanyToDomain));
    }

    clearGeneralData(companyId: number): Observable<void> {
        return this.companiesApi.clearGeneralData(companyId);
    }

    delete(companyId: number): Observable<void> {
        return this.companiesApi.delete(companyId);
    }
}
